import { createGetComponent } from '@repo/roche-xx-shared';
import { componentRegistry } from '../../components/custom';

export const getComponent = createGetComponent(componentRegistry);
